<template>
    <Modal>
        <template #title>Delete trim</template>

        <h2 class="color-red">Are you sure you want to DELETE this trim?</h2>

        <p><b>Trim:</b> {{ trim.trimName }}</p>
        <p><b>Description:</b> {{ trim.description }}</p>

        <template #footer>
            <Button class="gray" @click="closeModal">Cancel</Button>

            <Button class="red" :loading="sendStatus" @click="deleteConfirmed">Delete</Button>
        </template>
    </Modal>
</template>

<script>
    import { mapActions } from 'vuex';
    import Modal from "../Modal";
    import Button from "../Button";

    export default {
        name: "DeleteTrimModal",

        components: {
            Button,
            Modal
        },

        props: [
            'trim',
        ],

        data() {
            return {
                sendStatus: false,
            }
        },

        methods: {
            ...mapActions('trims', [
                'deleteTrim',
            ]),

            closeModal() {
                this.$emit('closeModal');
            },

            async deleteConfirmed() {
                this.sendStatus = true;
                
                const trimId = this.trim.id;

                await this.deleteTrim(trimId)
                    .finally(() => {
                        this.sendStatus = false;
                    });

                this.closeModal();
            },

        },

    }
</script>

<style scoped>

</style>